import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { createResourcePromptMenuItem, PROMPT_MENU_TYPE } from '../../lib';
import { BaseItemsList } from '../BaseItemsList';
import { MenuItem } from '../MenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  imageResources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  quickSearchMode: PropTypes.bool,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  quickSearchMode: false,
  noTags: false,
};

export const ItemsImage = ({ className, imageResources, onAction, quickSearchMode, noTags }) => {
  const styles = useStyles();

  const menuItems = useMemo(
    () => (imageResources || []).map(createResourcePromptMenuItem),
    [imageResources]
  );

  return (
    <BaseItemsList className={cx(styles.root, className)}>
      {menuItems.map((item) => (
        <MenuItem
          key={item.id}
          type={PROMPT_MENU_TYPE.image}
          item={item}
          onAction={onAction}
          menuType={PROMPT_MENU_TYPE.image}
          quickSearchMode={quickSearchMode}
          noTags={noTags}
        />
      ))}
    </BaseItemsList>
  );
};

ItemsImage.displayName = 'ItemsImage';
ItemsImage.propTypes = propTypes;
ItemsImage.defaultProps = defaultProps;
